import styled from 'styled-components'

interface FlexWrapperProps {
    terminalExpanded: boolean
}
export const FlexWrapper = styled.div<FlexWrapperProps>`
    flex: ${(props) => (props.terminalExpanded ? '0' : '1')};
`
